import { render, staticRenderFns } from "./TcInscriptionError.vue?vue&type=template&id=75d13c4f&"
import script from "./TcInscriptionError.vue?vue&type=script&lang=js&"
export * from "./TcInscriptionError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75d13c4f')) {
      api.createRecord('75d13c4f', component.options)
    } else {
      api.reload('75d13c4f', component.options)
    }
    module.hot.accept("./TcInscriptionError.vue?vue&type=template&id=75d13c4f&", function () {
      api.rerender('75d13c4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TcInscriptionError.vue"
export default component.exports